export enum FDADesignations {
  Breakthrough_Therapy = "Breakthrough Therapy",
  Fast_Track = "Fast Track",
  Accelerated_Approval = "Accelerated Approval",
  Priority_Review = "Priority Review",
  No_Recent_Development = "No Recent Development",
}

export enum SubmissionTypes {
  NDA = "NDA",
  BLA = "BLA",
  sNDA = "sNDA",
  sBLA = "sBLA",
  Biosimilar = "Biosimilar",
  // "NDA_505b2" = "505(b)(2)s",
  "NDA_505b2" = "505(b)(2) NDA",
}

export enum IndicationApprovalStageType {
  TBD = "TBD",
  CRL = "CRL",
  Extrapolation = "Extrapolation",
  Withdrawn = "Withdrawn",
  Discontinued = "Discontinued",
  Developing = "Developing",
  Pending = "Pending",
  Authorized = "Authorized",
  Approved = "Approved",
  TentativeApproval = "Tentative Approval",
  PreClinical = "Pre-Clinical",
  PhaseI = "Phase I",
  PhaseII = "Phase II",
  PhaseIII = "Phase III",
}

export enum ApprovalStatusSortOrder {
  Approved,
  "Tentative Approval",
  Authorized,
  Pending,
  "Phase III",
  "Phase II",
  "Phase I",
  "Pre-Clinical",
  Developing,
  CRL,
  Withdrawn,
  Discontinued,
  Extrapolation,
  TBD,
}

export enum DisplayedIndicationStageSortOrder {
  "Pending",
  "Tentative Approval",
  "CRL",
  "Phase III",
  "Phase II",
  "Phase I",
  "Pre-Clinical",
  "Withdrawn",
}

export enum DisplayedIndicationApprovalStageType {
  "Tentative Approval" = "Tentative Approval",
  "Pending" = "Pending",
  "Pre-Clinical" = "Pre-Clinical",
  "Phase I" = "Phase I",
  "Phase II" = "Phase II",
  "Phase III" = "Phase III",
  "Withdrawn" = "Withdrawn",
  "CRL" = "CRL",
}

export enum DisplayedStages {
  TentativeApproval = "Tentative Approval",
  Pending = "Pending",
  PreClinical = "Pre-Clinical",
  PhaseI = "Phase I",
  PhaseII = "Phase II",
  PhaseIII = "Phase III",
  Withdrawn = "Withdrawn",
  CRL = "CRL",
}
